import ScreenContainer from '../display/ui/ScreenContainer';
import ButtonSimple from '../ui/buttons/ButtonSimple';
// import CutscenePlayer from '../ui/CutscenePlayer';
import OverlayPlayerMode from '../ui/OverlayPlayerMode';
import OverlayLocation from '../ui/OverlayLocation';
import { getGA } from 'analytics/GoogleAnalytics';
import { PLAYER_SINGLE, GA_LABEL_PLAYER_1, GA_LABEL_PLAYER_2 } from 'app/constants/AppConstants';

export default class extends Phaser.State {
  init({ endOfLevel }) {
    this.endOfLevel = endOfLevel; // if return home is after end of level -> display location selection in 1 player mode
  }

  preload() {}

  create() {
    // store everything in a container, we will reposition this for screen
    this.container = new ScreenContainer(this.game, {
      title: '',
    });

    this.bg = this.game.make.image(0, 0, 'bg_welcome');
    this.container.addChild(this.bg);

    // logo
    this.logo = this.game.make.image(this.game.defaultWidth / 2, 145, 'logo_game');
    this.logo.anchor.set(0.5);
    this.container.addChild(this.logo);

    // start button
    this.btnStart = new ButtonSimple({ game: this.game, up: 'btn_play', over: 'btn_play' });
    this.btnStart.position.set(this.game.defaultWidth * 0.5, 385);
    this.btnStart.onInputDown.add(this.handleBtnStart, this);
    this.container.addChild(this.btnStart);

    //
    if (this.endOfLevel) {
      this.endOfLevel = false;
      this.showOverlayLocation();
    }

    //
    this.game.sounds.setBackgroundMusic('music_title', true);
    this.game.sounds.playBackgroundMusic();

    //
    const cptData = this.game.cache.getJSON('vo_ui_captions');
    this.game.springRollCaptionsPlugin.setData(cptData);
    const voId = 'ui_01_elinor_001';
    this.playVO(voId);
    // this.timeEvent = this.game.time.events.add(cptData[voId][0].end, this.playNextVO, this);
  }

  // playNextVO() {
  //   this.timeEvent = null;
  //   this.playVO('ui_01_elinor_002');
  // }

  playVO(id) {
    this.game.springRollCaptionsPlugin.playCaption(id);
    this.snd = this.game.sounds.playVO(id, { spriteID: 'vo_ui' });
  }

  handleBtnStart() {
    this.btnStart.onInputDown.remove(this.handleBtnStart, this);
    this.btnStart.visible = false;

    // enable audio
    this.game.sounds.checkAudioContext();

    // stop vo
    if (this.snd) {
      this.game.springRollCaptionsPlugin.stopCaption();
      this.snd.stop();
    }
    if (this.timeEvent) {
      this.game.time.events.remove(this.timeEvent);
      this.timeEvent = null;
    }

    //
    // getGA().track({ category: 'TEST', action: 'CLICK' });

    //
    this.showOverlayPlayerMode(true);
  }

  /*
  ====================================================================================
    DISPLAY OVERLAYS
  ====================================================================================
  */
  showOverlayPlayerMode(animateBg) {
    this.overlayPlayer = new OverlayPlayerMode(this.game, animateBg);
    this.overlayPlayer.onSelect.addOnce(this.handleSelectPlayerMode, this);
    this.overlayPlayer.onBack.addOnce(this.handleBackToHome, this);
    this.container.addChild(this.overlayPlayer);

    this.playVO('ui_01_elinor_004');
  }

  handleSelectPlayerMode(mode) {
    this.overlayPlayer.destroy();
    this.overlayPlayer = null;

    this.game.controller.playerMode = mode;

    //
    if (mode === PLAYER_SINGLE) {
      getGA().setLabel(GA_LABEL_PLAYER_1);
    } else {
      getGA().setLabel(GA_LABEL_PLAYER_2);
    }

    //
    if (this.game.controller.player.unlockedLocations > 1) {
      this.showOverlayLocation();
    } else {
      this.handleSelectLocation(0);
    }
  }

  handleBackToHome() {
    this.container.removeChild(this.overlayPlayer);
    this.overlayPlayer.destroy();
    this.overlayPlayer = null;

    this.btnStart.onInputDown.add(this.handleBtnStart, this);
    this.btnStart.visible = true;
  }

  showOverlayLocation() {
    this.overlayLocation = new OverlayLocation(this.game);
    this.overlayLocation.onSelect.addOnce(this.handleSelectLocation, this);
    this.overlayLocation.onBack.addOnce(this.handleBackToSelectPlayerMode, this);
    this.container.addChild(this.overlayLocation);
  }

  handleSelectLocation(ind) {
    if (this.overlayLocation) {
      this.overlayLocation.destroy();
      this.overlayLocation = null;
    }

    this.game.controller.setLocation(ind);

    //
    getGA().track({ action: 'GameStart' });

    //
    this.game.controller.startGame();
  }

  handleBackToSelectPlayerMode() {
    this.overlayLocation.destroy();
    this.overlayLocation = null;

    this.showOverlayPlayerMode(false);
  }

  shutdown() {
    this.game.sounds.stopBackgroundMusic();
    this.game.sounds.clearBackgroundMusic();

    // destroy
    this.container.destroy(true);

    // clear up
    this.container = null;
  }
}
